/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSessionsGet } from '../fn/session/api-sessions-get';
import { ApiSessionsGet$Params } from '../fn/session/api-sessions-get';
import { MultipleReturnGetSessionsDto } from '../models/multiple-return-get-sessions-dto';

@Injectable({ providedIn: 'root' })
export class SessionService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `apiSessionsGet()` */
    static readonly ApiSessionsGetPath = '/api/sessions';

    /**
     * Get all sessions (filter, order, skip, take).
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `apiSessionsGet()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiSessionsGet$Response(
        params?: ApiSessionsGet$Params,
        context?: HttpContext,
    ): Observable<StrictHttpResponse<MultipleReturnGetSessionsDto>> {
        return apiSessionsGet(this.http, this.rootUrl, params, context);
    }

    /**
     * Get all sessions (filter, order, skip, take).
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `apiSessionsGet$Response()` instead.
     *
     * This method doesn't expect any request body.
     */
    apiSessionsGet(params?: ApiSessionsGet$Params, context?: HttpContext): Observable<MultipleReturnGetSessionsDto> {
        return this.apiSessionsGet$Response(params, context).pipe(
            map((r: StrictHttpResponse<MultipleReturnGetSessionsDto>): MultipleReturnGetSessionsDto => r.body),
        );
    }
}
